import {combineReducers} from 'redux';
import {createReducer} from 'typesafe-actions';
import {
  eSingleClearData,
  eSingleLoadPlatesAsync,
  eSingleRequestVotingAsync,
} from './actions';
import {ISinglePlate, ISingleVoting} from './types';
import IInfo = MyTypes.IInfo;

const info = createReducer<IInfo>({loading: false, message: ''}) //
  .handleAction(
    [eSingleLoadPlatesAsync.request, eSingleRequestVotingAsync.request],
    () => ({
      loading: true,
      message: '',
    })
  )
  .handleAction(
    [
      eSingleClearData,
      eSingleLoadPlatesAsync.success,
      eSingleRequestVotingAsync.success,
    ],
    () => ({
      loading: false,
      message: '',
    })
  )
  .handleAction(
    [eSingleLoadPlatesAsync.failure, eSingleRequestVotingAsync.failure],
    (state, action) => ({
      loading: false,
      message: action.payload,
    })
  );

const plates = createReducer<ISinglePlate[]>([]) //
  .handleAction(eSingleLoadPlatesAsync.success, (state, action) => [
    ...action.payload,
  ])
  .handleAction(eSingleClearData, (state, action) => []);

const vote = createReducer<ISingleVoting[] | null>(null) //
  .handleAction(eSingleRequestVotingAsync.success, (state, action) => [
    ...action.payload,
  ]);
// .handleAction([clearData, requestVotingClear], (state, action) => null);

const eSingleReducer = combineReducers({
  info,
  vote,
  plates,
});

export default eSingleReducer;
export type ESingleState = ReturnType<typeof eSingleReducer>;



// WEBPACK FOOTER //
// ./src/features/election-single/store/reducer.ts